window.cardPopup = function () {
  const capitalize = (value) => {
    const text = String(value ?? '');
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  let qaButtons = document.querySelectorAll('[data-quick-add-button]');

  if (qaButtons) {
    qaButtons.forEach((btn) => {

      let qaPopup = btn.parentElement.querySelector('[data-quick-add-popup]');
      let qaClosePopup = qaPopup ? qaPopup.querySelector('[data-quick-add-close]') : null;


      //Handler for quick-add-button
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (variantId && typeof window.addVariantToCartFromCard === 'function') {
          await window.addVariantToCartFromCard(btn, variantId);
          return;
        }

        if (!qaPopup) return;

        qaPopup.classList.remove('hidden');
      });

      if (!qaPopup) return;

      if (qaClosePopup) {
        qaClosePopup.addEventListener('click', () => {
          qaPopup.classList.add('hidden');
        });
      }


      //Handler for Swatches
      const cardProduct = btn.closest('.card');
      let productColors = cardProduct.querySelector('.card__option-colors');
      if (!productColors) {
        return null;
      }
      let ColorSwatches = productColors.querySelectorAll('button');
      if (!ColorSwatches) {
        return null;
      }

      productColors.addEventListener('click', (event) => {

        if (event.target.type != 'button') {
          return null;
        }


        ColorSwatches.forEach((button) => {
          button.classList.remove('active');
          if (event.target == button && !button.classList.contains('disabled')) {
            button.classList.add('active');
            let col = capitalize(button.value);
            const example = cardProduct.querySelector('.custom-select');
            example.setChoiceByValue(col);
          }
        });
      });
    });
  }
};

window.cardPopup();

if (!window.__productCardColorSwatchesInit) {
  window.__productCardColorSwatchesInit = true;

  let buttonColors = document.querySelectorAll('.js-card__option-color');

  if (buttonColors) {
    buttonColors.forEach(item => {
      item.addEventListener('click', (e) => {
        const buttonColor = e.target;
        const buttonSrc = buttonColor.dataset.image;
        let mainImages = document.querySelectorAll('.js-card__media img');
        if (mainImages) {
          mainImages.forEach(element => {
            if (element.dataset.product == buttonColor.parentElement.dataset.product) {
              element.srcset = buttonSrc;
              element.src = buttonSrc;
            }
          });
        }
      });
    });
  }
}
